//Shapes.js
export const inventory = [
    'Syracuse 36334',
    'West Berlin F 3296',
    'Palermo 2198 (old no. 3480)',
    'Vatican U 21 (inv. 17969)',
    'Vienna 986',
    'Madrid 11026 (L. 388)',
    'Syracuse 36332',
    'Syracuse 36319',
    'Agrigento 11431',
    'Louvre K 249',
    'Voronezh (ex Dorpat 109)',
    'Gela (from the Acropolis)',
    'Lipari inv. 168 F (from T. 24)',
    'Copenhagen, N.M. 9183',
    'Los Angeles, Dechter coll.',
    'Louvre K 234',
    'Louvre K 237',
    'Naples 2097 (inv. 81465)',
    'Once Deepdene, Hope coll. 263',
    'Mainz, RGZM 0.13000',
    'Rennes D 895.1.67',
    'Naples RC 265 (inv. 86405 = Heyd. 47), from Cumae',
    'Naples 2074 (inv. 81437)',
    'Naples, private coll. (1) 508',
    'Melbourne, Graham Geddes coll. C 1: 2',
    'Odessa 23092',
    'Paestum, from S. Venera',
    'Rome, private coll.',
    'Once Los Angeles Market, Summa Galleries, inv. 247',
    'San Simeon 5426 (SSW 9847)',
    'B.M. F 129, from Nola (Blacas Tomb)',
    'B.M. F 130, from Nola (Blacas Tomb)',
    'Louvre G 517',
    'Tirana, Arch. Mus., inv. 68',
    'Basel, private coll.',
    'Mainz, RGZM 0.12946',
    'Laon 37.1074',
    'Udine 1538',
    'Vatican U 52 (inv. 18000)',
    'Heligoland, Kropatschek coll. 114',
    'Warsaw 147300',
    'Madrid 32653 (ex Prado 120)',
    'Syracuse 47102',
    'Lipari 9671',
    'Lipari 11806',
    'Lipari 6814',
    'Ragusa, private coll.',
    'Once Geneva Market, Koutoulakis-Zimmermann',
    'Once Zurich Market, Arete',
    'Once Nocera, Fienga coll. (inv. De F. 582)',
    'Madrid 11033 (L. 381)',
    'Gela 298',
    'Naples',
    'Gela, Iacona coll.',
    'Cefalù 8',
    'Bari, Cotecchia coll. 60',
    'Baranello 203',
    'Ragusa, Museo Archeologico (ex La Rocca coll.)',
    'Once Frankfurt Market',
    'Bern D 5, on loan from Dr. C. Clairmont',
    'Locri 1969/150 A - C, from Locri',
    'Louvre K 236',
    'Melbourne, Graham Geddes coll. C 1:0',
    'Canberra 83.01',
    'Reggio Cal. S4799',
    'B.M. F 140',
    'Reggio Cal., from Locri (fr.)',
    'Louvre K 344',
    'Berlin F2960',
    'Once Basel Market, MuM',
    'Bologna 437',
    'Bologna 491',
    'Tischbein 134',
    'Cefalu 7',
    'Naples 3126',
    'Once Zurich, Ruesch coll.',
    'Naples 147324',
    'Dublin, University College 1468',
    'Brisbane, University of Queensland 64.1',
    'B.M. F10',
    'Cefalu 2',
    'Once Hasselmann coll.',
    'Syracuse 14625',
    'Syracuse 51282',
    'Louvre K235',
    'Naples 146775',
    'Catania, University, Arch. Inst. 9422',
    'Lipari 11807',
    'Lipari 9604',
    'Lipari 9558',
    'Various',
    'Louvre K 240',
    'S. Agata 66',
    'Naples, private coll. (2) 1-1-13',
    'Madrid 32661 (Prado 150)',
    'Louvre K 241',
    'Lipari 927',
    'Taranto 56246',
    'Once New York Market, Atlantis Gallery',
    'Gela 8255-6',
    'Syracuse 29966',
    'North German private coll.',
    'Leningrad 1660 (St. 1777)',
    'Malibu 80 AE 153',
    'Palermo, Bank of Sicily—Mormino coll. 385, from Selinunte',
    'Madrid 11449',
    'Geneva H R 29',
    'New York 1985.74',
    'Madrid 11138 (L. 422)',
    'Paestum IV/452',
    'Paestum 3907 BA',
    'Paestum 6455',
    'New York Market, Royal-Athena Galleries H F N 06',
    'Basel Z 313',
    'Naples, private coll. (2) 4-1-5',
    'Paestum 32113, from Tempa Rossa di Fonte (1964), T. 2',
    'Paestum 48455, from C. Arcioni (1977), T. 271',
    'Madrid 11137',
    'Madrid 11142 (L. 421)',
    'Karlsruhe B 91 (W. 375)',
    'Paestum 22449, from C. Andriuolo (1969), T. 102',
    'Paestum 22443, from C. Andriuolo (1969), T. 102',
    'Mainz O. 29212',
    'Paestum, from Pontecagnano, T. 18 (6.7.1960)',
    'Salerno Mus. Prov., Pc 1812, from Pontecagnano',
    'Madrid 11037 (L. 383)',
    'Naples 781 (inv. 82603)',
    'Paestum, from S. Venera (sanctuary, sporadic)',
    'Paestum 20386, from C. Licinella (1967), T. 31',
    'Melbourne D 391/1980',
    'Los Angeles, Sidney Port coll. (ex Summa Galleries, inv. 82)',
    'B.M. F 188',
    'Hillsborough, Mrs. R. A. Hearst coll. 23, ex San Simeon 5434',
    'Vienna 581',
    'Once Zurich Market, Arete 2252',
    'Naples, private coll. (2) 4-5-2',
    'Paestum 28901, from C. Andriuolo (1969), sporadic',
    'Oxford 1945. 43',
    'Naples, private coll. (2) 4-1-1',
    'Paestum 21206',
    'Collonges (Geneva), private coll.',
    'Madrid 11019',
    'Madrid 11059',
    'Bologna 490',
    'Benevento, from Montesarchio, T. 1625',
    'B.M. F 153',
    'Turin 4703',
    'Dublin 1880-510',
    'Madrid 11062',
    'B.M. F 150',
    'Once Agrigento, Giudice coll. 193',
    'Benevento 348 (old no. 1503), from Moiano',
    'Salerno, Mus. Prov., from Oliveto Citra',
    'S. Agata 184',
    'Salerno, Mus. Prov., Pc 1813, from Pontecagnano',
    'Pontecagnano 36420, from T. 1183',
    'Pontecagnano 36525, from T. 1255',
    'Pontecagnano 36475, from T. 901',
    'B.M. F 152',
    'Naples 181117',
    'Paestum 1748, from area N. of Porta Aurea',
    'Geneva, private coll.',
    'Lecce 741, from Rugge',
    'New York 62.11.3',
    'Madrid 11058',
    'New York, private coll. x85; once Nostell Priory 28',
    'Madrid 11054',
    'Tampa (Florida), W . K. Zewadski coll.',
    'Madrid 11060',
    'Naples 905 (inv. 82620)',
    'Florence, Vagnonville 671',
    'Paestum 6249, from C. Laghetto (1956), T. 3',
    'Naples, private coll. (2) 4-5-1',
    'Paestum 1741, from area N. of the Porta Aurea',
    '70 Madrid, Garcia coll.',
    'Pontecagnano, from T. 3711, no. 12',
    'B.M. F 360',
    'Once Basel Market, M u M',
    'Karlsruhe B 92 (W. 351)',
    'Paestum 21622, from C. Andriuolo (1969), T. 61',
    'Berlin F 3033',
    'Berlin F 3032',
    'Tokyo, private coll. (ex N e w York and Tokyo Markets)',
    'Hamburg, Termer coll.',
    'Once Deepdene, Hope 264',
    'Louvre K 286',
    'Paestum 21586, from C. Andriuolo (1969), T. 56',
    'Munich 3295 (seemingly destroyed in World War II)',
    'Lost, once Naples, Jamineau',
    'Paestum',
    'Paestum H U / 3 7, from the area of the Heraion.',
    'London Market, McAlpine GR 466',
    '87 Madrid 11232',
    '88 Naples 1777',
    '89 Madrid 11231',
    'Louvre K 303',
    'Paestum 26607',
    'Naples, private coll.',
    'Pontecagnano 36402',
    'Pontecagnano 26230',
    'Pontecagnano 36476',
    'Once Paris Market, Samarcande',
    'Paestum 21514',
    'Salerno, Sopr. Arch. 38128',
    'Paestum 40987',
    'Madrid 11462',
    'Madrid 11453',
    'Paestum 48456',
    'Naples 2389',
    'Paestum 22441',
    'Paestum 48461',
    'Paestum 48460',
    'Pontecagnano, from T. 569',
    'Pontecagnano, from T. 3711, no. 31',
    'Paestum 40986',
    'Paestum, from S. Venera (1976), T. 80',
    'Paestum 48462',
    'Hamburg, Schwarzkopf coll.',
    'Paestum 24261',
    'Paestum 22294',
    'Boston 12.423',
    'Paestum 5639',
    'Salerno, Mus. Prov.',
    'Paestum 22949',
    'Salerno, Mus. Prov. 1546',
    'Louvre K 24',
    'Pontecagnano 26228',
    'Paestum 21449',
    'Paestum 32048',
    'Paestum 1749',
    'Berlin F3044',
    'Naples 3412',
    'Madrid 11094',
    'San Antonio 275',
    'Malibu 81 A E 78',
    '129A Once Market',
    'Rome, Villa Giulia 50279',
    'Salerno, from Buccino',
    'Naples 3226',
    '133 San Antonio (Texas), Gilbert M. Denman Jr. coll. 276',
    '134 Paestum 20202, from Agropoli (Muoio, C. Vecchia, 1967)',
    '135 Naples 2873 (inv. 81847), from Paestum',
    'Sydney 4901',
    'Paestum 21306, from C. Andriuolo (1969), T. 20',
    'Kassel T 821, ex Basel and London Markets',
    'Basel Market, M u M',
    'San Antonio S A M A 86-32 P(2) (ex Denman coll. 346)',
    'Louvre K 570',
    'Basel, Antikenmuseum',
    'Paestum 4794, from C. Gaudo (1957), T. 2',
    'Bochum S 1080',
    '144 Paestum 3781-3, 3789, 3793, from Temple B in the Temenos',
    '45 Paestum, from C. Licinella (1968)—sporadic, environs of T. 6-8',
    '146A Paestum 28872, from C. Andriuolo (1969)—sporadic',
    '146B Paestum 28847, from C. Andriuolo (1969)—sporadic',
    '147 Brussels A 813',
    '148 Paestum 48431, from the area of the Heraion',
    '149 Paestum 32128, from Tempa Rossa di Fonte (1964)',
    '150 Paestum 20161, from Agropoli (Muoio, C. Vecchia, 1967)',
    '151 Paestum 26631, from C. Gaudo (1972), T. 2',
    '152 Paestum 26633, from C. Gauda (1972), T. 2',
    '153 Paestum 26636, from C. Gauda (1972), T. 2',
    '154 Paestum 26635, from C. Gaudo (1972), T. 2',
    '155 Paestum 26638, from C. Gaudo (1972), T. 2',
    '156 Paestum 26632, from C. Gaudo (1972), T. 2',
    '157 Paestum 20210, from C. Licinella (1967), T. 10',
    '158 Paestum 4807, from C. Gaudo (1953), T. 2',
    '159 Paestum 21192, from C. Andriuolo (1969), T. 9',
    '160 Paestum, from C. Gaudo (1970), T. 1',
    '161 Paestum HU/33 (= NF 8), from area of Heraion (Loc. IV)',
    '162 Paestum 21135, from C. Andriuolo (1969), T. 1',
    '163 Paestum 21555, from C. Andriuolo (1969), T. 53',
    '164 Once Nocera, Fienga coll.',
    '165 From Eboli',
    '166 Madrid 11235 (L. 396)',
    '167 Naples, private coll. (2) 4-21-1',
    '168 Madrid 11278',
    '169 Paestum 26652, from C. Gaudo (1972), T. 3',
    '170 Dublin 1880-505',
    '171 Salerno, Soprintendenza, from Montesarchio, T. 1550',
    '172 Paestum 24294, from C. Andriuolo (1970), T. 147',
    '173 Paestum 20198, from Agropoli (Muoio, 1967), T. 11',
    '174 Rheinland, private coll.',
    '175 Salerno, Mus. Prov. Pc 1525, from Pontecagnano',
    '176 Vatican U 19 (inv. 17106)',
    '177 Madrid 11028 (L. 387)',
    '178 Once Leeuwarden, A. C. Beeling',
    '179 Madrid 11069 (L. 374)',
    '180 Pontecagnano, from T. 5173',
    '181 Paestum, from C. Laghetto (1955), T. 64',
    '182 New York, David Rockefeller coll.',
    '183 Geneva',
    '184 Geneva',
    '185 Paestum 20201, from Agropoli',
    '*186 Madrid 11445 (L. 433)',
    '187 Naples 2878 (inv. 81879)',
    '188 Madrid 11455 (L. 435)',
    '189 Naples, private coll. (1) 107',
    'Madrid 11441 (L. 437)',
    'Paestum 21429 (1969), T. 32',
    'Melbourne, Geddes coll. P 2:1',
    'Rome, Villa Giulia 50658',
    'Siena, Chigi-Zondadori coll. 269',
    'Paestum 21517 (1969), T. 47',
    'Melbourne, Geddes coll. P2:2',
    'Paestum 21624 (1969), T. 61',
    'Paestum 21623 (1969), T. 61',
    'Paestum 5398 (1954), T. 2',
    'Once Freiburg Market, G. Puhze',
    'Paestum, Loc. IV',
    'Paestum 3908 (= NF 9)',
    'Leiden K 1959/2',
    'Paestum 21600',
    'Paestum 31991',
    'Madrid 11307',
    'Madrid 11308',
    'Cambridge, Mr. R. Way',
    'Paestum 32129',
    'Meer, private coll. F 17',
    'Geneva, Dr. J. Chamay',
    'Bourges 891.5.66',
    'Copenhagen inv. Chr. VIII 337 (= B.-S. 258)',
    'Vienna 413',
    'S. Agata 196',
    'Milan 261',
    'Berlin F 3058, from Nola',
    'Madrid 11484 (L. 479)',
    'New York Market, Royal-Athena Galleries H F N 08',
    'Scottsdale (Arizona), L. M . Cutler coll.',
    'Once London Market, Charles Ede Ltd.',
    'Japanese private coll.',
    'Frankfurt p 593',
    'Westphalian private coll.',
    'Malibu 81 A E 120',
    'Salerno, M u s . Prov., from Pontecagnano',
    'Salerno, M u s . Prov., from Altavilla',
    'Woburn Abbey',
    'Salerno (Soprintendenza), from Montesarchio, T. 1713',
    'Louvre K 247',
    'Plymouth, City Museum',
    'Poughkeepsie (N.Y.), Vassar College 48.235',
    'Tokyo Market, Sotheby\'s at Mitsukoshi, Sale Cat. 1-2 Oct. 1969, no. 50',
    'Oxford 1942.293',
    'Cambridge G R 7 . 1943 (ex M u s e u m Disneianum)',
    'Louvre K 248',
    'Oxford 1928.12 (ex H o p e 275)',
    'B.M. F 149, from S. Agata',
    'Paestum 21370, from C. Andriuolo (1969), T. 24',
    'Louvre N 3157, from S. Agata',
    'Bari 3581, from Taranto',
    'Berlin F 3297 a',
    'B.M. 1917.12-10.1 (ex Hope 267)',
    'Vatican AD 1 (inv. 17370)',
    'Paestum 24323, from C. Andriuolo (1970)—sporadic',
    'B.M., from the wreck of the Colossus',
    'Paestum 21369',
    'B.M. F 155',
    'Paestum (on loan to the University of Salerno)',
    'Louvre K 264',
    'Benevento 28223',
    'Louvre K 242',
    'Copenhagen inv. Chr. VIII 290 (B.-S. 257B)',
    'New York, private coll, X99; once Nostell Priory (C. 36)',
    'Berlin F3050',
    'Naples, private coll. (2) 4-1-8',
    'Vatican U 18 (inv. 17966)',
    'Salerno (Soprintendenza), from Montesarchio, T. 1014',
    'Benevento 28208',
    'Christchurch (N.Z.), University of Canterbury 106/70',
    'Benevento 348 xviii',
    'Dundee 67-6-6',
    'Dunedin E48.261',
    'Once Agrigento',
    'Benevento 613S',
    'Florence, private coll.',
    'Sydney 47.04',
    'Sydney 48.04',
    'Richmond (Virginia)',
    'Berlin inv. 4532',
    'Sydney 49.09',
    'Basel Market',
    'Reading 51.7.11',
    'Melbourne, Geddes coll.',
    'London Market',
    'Louvre K 243',
    'Wurzburg H 5771',
    'Hanover R 1906.160',
    'B.M. F 189, from Capua',
    'Liverpool M 10711',
    'Once Ravello, Tallon-Lacaita coll., then Neuilly-sur-Seine, Ellen Lubszynski.',
    'St. David\'s (Pa.), Mrs. John F. Arndt',
    'The Hague, Schneider-Herrmann coll. 136 (inv. 19)',
    'Richmond (Virginia) 81.72',
    'Once Lucerne Market, Ars Antiqua',
    'Pontecagnano, from T. 4212',
    'Naples 2846 (inv. 81417), from S. Agata',
    'Sydney W 5 (42.02) (ex Hope 270)',
    'Los Angeles 50.8.30 (ex Hope 273)',
    'Los Angeles 50.8.40 (ex Hope 271)',
    'Mannheim C g 3',
    'Once Deepdene, Hope 276',
    'Once Deepdene, Hope 277',
    'Once Naples, Pacileo',
    'Tischbein I 40',
    'Tischbein I 41',
    'Tischbein I 44',
    'Tischbein II 52',
    'Louvre K 238',
    'Boston 95.834',
    'Boston 95.835',
    'Benevento 614 S',
    'Benevento, from Montesarchio, T. 1310',
    'Chicago, N.H.M. 166575',
    'Louvre K 244',
    'S. Agata 178',
    'Vatican U23',
    'Bonn 3038',
    'Warsaw 147269',
    'Vatican U 15',
    'S. Agata 145',
    'S. Agata 76',
    'Stockholm, C. E. Gait',
    'Pontecagnano 16306',
    'Pontecagnano 36901',
    'Louvre K250',
    'Paestum 31906',
    'Trieste 1816',
    'Madrid 11067',
    'Pontecagnano 10377',
    'Toulouse 26.340',
    'Compiegne 1069',
    'Compiegne 1026',
    'Naples, private coll. (2) 4-1-6',
    'New York 1976.11.5',
    'Once London Market, Charles Ede Ltd. (2197); ex Sotheby, Sale Cat. 11 Dec. 1984, no. 578,1; GPSIXll (1987), no. 1 (ill.)',
    'Once New York Market, Sotheby Parke Bernet, Sale Cat. 13 May 1978, no. 53 (ill. on p. 13)',
    'Naples, private coll. (2) 4-1-2',
    'Once London Market, Sotheby, Sale Cat. 8-9 Dec. 1986, no. 179, ex New York Market, Royal-Athena Galleries HFK 03',
    'Vatican U 17 (inv. 17965)',
    'Monopoli, Meo-Evoli coll. 212',
    'Naples 1774 (inv. 81659)',
    'Vatican U 25 (inv. 17973)',
    'Leiden K 1957/2. 1',
    'Naples 818 (inv. 82617)',
    'Pontecagnano 16315, from T. 909',
    'Pontecagnano 36159, from T. 1182',
    'Once Karlsruhe, Vogell coll. 549',
    'Paestum 31897, from Roccadaspide, Fondo Castagno',
    'Naples 824 (inv. 82613)',
    'Berlin F3049',
    'London Market, Charles Ede Ltd., ex Sotheby, Sale Cat. 8-9 Dec. 1986, no. 191',
    'Vatican, Astarita 50',
    'Westphalia, D.J. coll. 48',
    'Bucharest M.N.A. 74926 (ex Lens coll. 0427)',
    'Louvre K257',
    'New York Market, Royal-Athena Galleries',
    'Kassel T646',
    'Copenhagen 8377',
    'Paestum 31728',
    'Paestum 21476',
    'Naples, private coll. (2), 4-6-2',
    'Naples S N 76 D G',
    'Louvre K 3 0 1',
    'Once Berlin, Dr. Lederer',
    'Naples, private coll. (2) 4-6-1',
    'Paestum 4965, from C. Gaudo (1957), T. 11',
    'Mannheim C g 144',
    'Once Nocera, Fienga coll. 554',
    'Barcelona',
    'Paestum 7430, from Muoio d\'Agropoli (1967), T. 1',
    'Naples, private coll. (2) 4-6-3',
    'Paestum, from C. Spina-Gaudo (1977), T. 1',
    'Louvre K 308',
    'Paestum 777, from Spinazzo',
    'Salerno, Mus. Prov. Pc 1317, from Pontecagnano, T. 5',
    'Paestum 20368, from C. Licinella (1967), T. 30',
    'Louvre K 287',
    'Westphalia, D.J. coll. 49',
    'Naples 1787 (inv. 81684), from Paestum',
    'Boston 19.295, from Paestum',
    'Once Ascona, Galleria Serodine, List 1984, no. 57',
    'Vienna 206',
    'Louvre K363',
    'Louvre K364',
    'Paestum 7424, from Agropoli (1967), T. 1',
    'Wurzburg H 5739',
    'Paestum 20199',
    'Melbourne, Geddes coll. P.6:0',
    'Once Zurich Market, Bukowski,4 Sale Cat. 8 Dec. 1983, no. 134 (ill.)',
    'Benevento 28205',
    'Salerno (Sopr. Arch.), from Montesarchio, T. 891',
    'Naples 1786 (inv. 82178)',
    'Salerno, Sopr. Arch. 38132, from Avella (1981), T. 62 bis',
    'Warsaw 138062 (ex Majewski Museum 16283)',
    'Paestum 41158, from Santa Venera (1976), T. 107',
    'San Francisco, private coll. (Dr. and Mrs. Oremland), ex New York Market, Sotheby, Sale Cat. 24 Nov. 1986, no. 75 (ill.)',
    'Paestum 21518, from C. Andriuolo (1969), T. 47',
    'SAMA 86-10 P (2)',
    'Paestum 5047',
    'Paestum 26654',
    'Paestum 21472',
    'Paestum 21480',
    'Paestum 20371',
    'Paestum 21386',
    'Madrid 11458',
    'Paestum 21388',
    'Area of Heraion',
    'Paestum 21387',
    'Madrid 11139',
    'Madrid 11388',
    'Paestum 20197',
    'Paestum 21568',
    'Paestum 21390',
    'B.M. 67.5-8.1318',
    'Athens Market',
    'B.M. F 357',
    'Salerno',
    'Pontecagnano',
    'Warsaw 147160',
    'Paestum 21389',
    'Malibu',
    'Los Angeles Market',
    'Vienna',
    'Okayama, Kurashiki Ninagawa Museum 79',
    'Basel Market, MuM',
    'Reading 50.5.2',
    'Naples 1890 (inv. 81721)',
    'Thonon, Numifrance',
    'Sydney 49.10',
    'Pontecagnano 26319',
    'Geneva I 435',
    'Rome Market',
    'Naples 1772 (inv. 82243)',
    'Pontecagnano, Salerno',
    'Paestum, Badolato (Velia)',
    'Paestum, C. Spina Gaudo (7.11.73)',
    'Lost',
    'Paestum (once Salerno, Soprintendenza)',
    'Salerno (Soprintendenza)',
    'Rio de Janeiro 1529',
    'B.M. 67.5-8.1275',
    'B.M. 67.5-8.1276',
    'Pontecagnano, from Pontecagnano',
    'Naples 2245',
    'Once Treben, von Leesen 135',
    'Paestum 1274',
    'Paestum 1765',
    'Madrid 11259',
    'Vienna 1133',
    'Paestum, from Roccadaspide Tempalta',
    'Paestum 5695',
    'Paestum 5445',
    'Narbonne 3684 (26)',
    'Paestum 7449',
    'Paestum 21207',
    'Paestum 25009',
    'Pontecagnano 26241',
    'Limoges 7910',
    'Paestum 31669',
    'Paestum 32244',
    'Paestum 21528',
    'Lugano, private coll. 194',
    'Salerno, Mus. Prov., from Pontecagnano',
    'Madrid 11240 (L. 403)',
    'Madrid 11245',
    'Madrid 11246',
    'Pontecagnano 26414, from T. 794',
    'Once Zurich Market, Arete inv. 2867',
    'Once Gy (Geneva), Dr. Lauffenburger',
    'Paestum 24985, from C. Andriuolo',
    'Naples 128035, from Cumae',
    'Paestum, from Pontecagnano (sporadic)',
    'Paestum 4988, from C. Gaudo',
    'Naples 186375',
    'Paestum 22756, from C. Licinella',
    'Paestum 24984, from C. Andriuolo',
    'Paestum 5447',
    'Pontecagnano 26227',
    'Madrid 11243 (L. 414)',
    'Manchester IV E 5',
    'Paestum 22641',
    'Pontecagnano 26412',
    'Padula',
    'Salerno, Mus. Prov., from Altavilla',
    'Mainz, R G Z M O',
    'Paestum 21483',
    'Catania 4327',
    'Once London Market, Christie\'s',
    'Berlin F 3026, from Calvi',
    'Naples 2233 (inv. 81787), from Paestum',
    'Madrid 11205 (L. 489)',
    'Paestum 20315',
    'Pontecagnano 36503',
    'London Market, Coins and Antiquities AN 703',
    'Paestum 41159',
    'Nocera, Fienga 595',
    'Paestum 32893',
    'Paestum 22950',
    'Paestum 5528',
    'Paestum 5437',
    'Paestum 21218',
    'Naples Stg. 432',
    'Paestum 32255',
    'Madrid 11206',
    'B.M. 1977.5-22.36',
    'Paestum 21235',
    'Paestum 21557',
    'London Market, Charles Ede Ltd.',
    'Japan, private coll.',
    'Paestum 21428',
    'Madrid 11148',
    'Madrid 11149',
    'Palermo',
    'Auxerre 9',
    'Paestum 21453',
    'Paestum 21466',
    'Paestum 21503',
    'Paestum 24986',
    'Paestum 32382',
    'Paestum 39103',
    'San Antonio (Texas), Gilbert M. Denman Jr. coll. 318',
    'Madrid 11150',
    'Naples 1888',
    'Once Nocera, Fienga coll. 568',
    'Paestum 32308',
    'Paestum 21570',
    'Buenos Aires, University—Museo Etnografico 44',
    'Paestum 32030',
    'Salerno, Museo Prov., from Pontecagnano',
    'Pontecagnano 36145, from T. 1182',
    'Berlin F 4100',
    'Purchase (N.Y.), Neuberger Museum 71.1.15, ex Nelson Rockefeller coll.',
    'Madrid 11152 (L. 429)',
    'Madrid 11151 (L. 428)',
    'Madrid 11147 (L. 427)',
    'Paestum 21973, from C. Andriuolo (1969), T. 178',
    'Paestum 31863, from Gromola (Strecara—1960), T. 1',
    'Vienna 932',
    'Avignon, Musee Calvet',
    'Paestum 21143, from C. Andriuolo (1969), T. 1',
    'Paestum 21441, from C. Andriuolo (1969), T. 38',
    'Paestum, from Roccadaspide Tempalta (1984), T. 1',
    'Paestum 5577, from C. Andriuolo (1954), T. 47',
    'Once Basel Market, Kunsthaus zum Gellert, Sale Cat. no. 24, 26-28 Nov. 1981, no. 2282',
    'Once London Market, Christie\'s, South Kensington, Sale Cat. 18 May 1983, no. 121',
    'Padula, from Valle Pupina, T. 16',
    'Basel, Historisches Museum 1906.268',
    'Louvre CA 2270',
    'Madrid 11146 (L. 425)',
    'Paestum 32243, from Spinazzo (1973), T. 9',
    'Pontecagnano 26325, from T. 450',
    'Naples 736 (inv. 82737)',
    'Berlin F 4129',
    'Paestum 21595',
    'Paestum 5441',
    'Cologne Market',
    'Nostell Priory 41',
    'Paestum 4978',
    'Paestum 1252',
    'Paestum 21136',
    'Paestum 21259',
    'Paestum 41125',
    'Paestum 21452',
    'Paestum 21460',
    'Paestum 21548',
    'Pontecagnano 26245',
    'Paestum 25010',
    'Paestum 31918',
    'Salerno, Mus. Prov. 1450',
    'Madrid 11459',
    'Urbana-Champaign, Univ. of Illinois, World Heritage Museum 22.1.73',
    'London Market, Sotheby',
    'Paestum 5578',
    'Zurich Market, Arete',
    'Pontecagnano 36117',
    'Padula, Valle Pupina',
    'Salerno, Mus. Prov. 1335',
    'Paestum 20369',
    'Madrid, no. lost',
    'Boston 19.299',
    'Paestum 5974',
    'Paestum, from Roccadaspide Tempalta (1984)',
    'Paestum 6014',
    'Paestum, from C. Andriuolo-Laghetto (1955)',
    'Paestum 1253',
    'Madrid 11451 (L.445)',
    'Paestum 5272',
    'Salerno, Sopr. Arch. 38127',
    'Berkeley, U C L M A 8/446',
    'Copenhagen, N y Carlsberg H 53',
    'Paestum 5981',
    'Paestum 4973',
    'Okayama, Kurashiki Museum 79',
    'Padula, from Tepedino',
    'Paestum 32029',
    'Paestum 21495',
    'Detroit 24.156',
    'Paestum 21504',
    'Paestum 41156',
    'Paestum 32068',
    'Paestum 5433',
    'Salerno, Mus. Prov. 1552',
    'Salerno (Soprintendenza) V D 38-39',
    'Paris, Cab. Med. 962',
    'Paestum 21137',
    'Paestum 21138',
    'Melbourne University V53',
    'Pontecagnano 36118',
    'Paestum 32115',
    'Paestum 21632',
    'Reading, University 22.iii.23 (lid only)',
    'Paestum 4975',
    'B.M. 1953.4-25.1',
    'Paestum 24987',
    'Paestum 5434',
    'Pontecagnano, from T. 3711, no. 28',
    'Geneva I 462',
    'Louvre K573',
    'Paestum 5392',
    'Rheinbach, Koch coll.',
    'Rheinbach, C. Koch coll.',
    'Paris Market, Galerie Antonovich 1151',
    'Paestum from C. Spina-Gaudo (1979)',
    'Madrid 11318',
    'Paestum 6120, from C. Andriuolo-Laghetto (1955)',
    'Paestum 20211, from C. Licinella (1967)',
    'Paestum 21585, from C. Andriuolo (1969)',
    'Paestum, from C. Spina-Gaudo (30.8.1975)',
    'Paestum 1247, from Spinazzo',
    'Paestum 1248, from Spinazzo',
    'Turin 4585',
    'Paestum 21456, from C. Andriuolo (1969)',
    'Paestum 32058, from C. Spina (1963)',
    'Madrid 11335 (L. 522; lid only)',
    'Taranto, Ragusa coll. 64',
    'Leningrad inv. 3044',
    'Paestum 20370, from C. Licinella (1967)',
    'Como C 128',
    'Paestum 7457, from Agropoli',
    'New York, Royal-Athena Galleries',
    'Tokyo Market, Sotheby-Mitsukoshi',
    'Naples 1853, from Paestum',
    'Paestum 32036, from C. Spina (1963)',
    'Rome Market, Benedetti',
    'Paestum 5444, from C. Andriuolo (1954)',
    'Paestum 25012, from C. Andriuolo (1971)',
    'Paestum 32247, from C. Gaudo (1973)',
    'Geneva Market, Koutoulakis 256',
    'Paestum 39104, from C. Gaudo',
    'Paestum 25011, from C. Andriuolo (1971)',
    'Paestum 25053',
    'Madrid 11325',
    'Paestum 21173',
    'Paestum 31700',
    'Pontecagnano 26224',
    'Leipzig T 4740',
    'Stockholm N.M. 82',
    'Paestum 22258',
    'Paestum 5667',
    'Madrid 11519',
    'Vatican U 22',
    'Madrid 11524',
    'Madrid 11529',
    'Madrid 11539',
    'Paestum 6257',
    'Paestum 20137',
    'Dunedin E 23.8',
    'Paestum 21582',
    'Madrid 11583',
    'Paestum 5554',
    'Paestum 6013',
    'Paestum 4990',
    'Paestum 32038',
    'Paestum 32062',
    'Melbourne, Geddes coll. P 3:1',
    'Once Rome Market',
    'Haverford (Pa.), Haverford College 5',
    'Paestum 26655',
    'Pontecagnano 26226',
    'Pontecagnano 26231',
    'Paestum 6192',
    'Paestum 22780',
    'Paestum 6509',
    'Madrid 11523',
    'Moscow, Pushkin Museum 185',
    'Paestum 31972',
    'Madrid 11534',
    'Paestum 21193',
    'Paestum 7425',
    'Rothenbach-Pegnitz',
    'Paestum 31726',
    'Paestum 5051',
    'Paestum 20316',
    'Paestum 21470',
    'Paestum 31712',
    'Madrid 11526',
    'Paestum 22174',
    'Oxford 1945.68',
    'Salerno, Soprintendenza V D 58',
    'Paestum, C. Spina-Gaudo (1979), T. 64',
    'Paestum 31713',
    'Kiel B 555',
    'B.M. F 243',
    'Paestum 21423',
    'Roccadaspide Tempalta',
    'Paestum 32250',
    'Naples, private coll. (2) 4-9-1',
    'Naples, private coll. (2) 4-9-2',
    'Madrid 11564',
    'Paestum 21424',
    'Zurich Market, Arete 3013',
    'Montpellier, Musee Fabre 39.1678',
    'Once London Market, Sotheby, Sale Cat. 13 July 1976, no. 444, ill. on p. 178',
    'B.M. F 371',
    'S. Agata 199',
    'Paestum 4961, from C. Gaudo (1957), T. 11',
    'Pontecagnano 16721, from T. 949bis',
    'Joliet (111.), Harlan J. Berk',
    'Paestum 31727, from C. Vannullo (1975), T. 3',
    'Paestum 6109, from C. Andriuolo-Laghetto (1955), T. 64',
    'Rennes D 863.1.27',
    'Paestum 22781, from C. Licinella (1968), T. 40',
    'Bologna 436',
    'Stockport, Municipal Museum L.206.77',
    'Paestum 21535, from C. Andriuolo (1969), T. 50',
    'Paestum (fragment), from the Foce del Sele',
    'Madrid 11499 (L. 481)',
    'Rio de Janeiro 1488',
    'Paestum, from C. Spina-Gaudo (1979), T. 67',
    'Los Angeles Market, Barakat Gallery PF 292',
    'Leiden G N V 138',
    'Rome, Museo Pigorini 93639, from Grotta di Pertosa (Salerno)',
    'Once Nostell Priory, Sale Cat. no. 31 c, pi. 11,5',
    'Paestum, from Agropoli (1967), T. 1',
    'Paestum 21191, from C. Andriuolo (1969), T. 9',
    'Paestum 22257, from C. Andriuolo (1969), T. 84',
    'Paestum 31714, from C. Vannullo (1975)',
    'Paestum 32050, from C. Spina (1963), T. 9',
    'Rheinbach, E. Koch coll.',
    'Madrid 11496 (L. 475)',
    'Paestum 31975, from Altavilla (1953), T. 1',
    'Jena 257 (431)',
    'Naples, private coll. (2) 4-16-1',
    'Pontecagnano 26323',
    'Naples, private coll. (2) 4-16-2',
    'Cologne, Tollmann coll.',
    'Canberra, A.N.U.',
    'Madrid 11489',
    'Madrid 11491 (L. 488)',
    'Berlin F 3069',
    'Paestum 21141, from C. Andriuolo (1969), T. 1',
    'Haverford, Haverford College 6',
    'Paestum 21232, from C. Andriuolo (1969), T. 14',
    'Madrid 11488 (L. 349)',
    'B.M. F 393 (1772.3-20.228)',
    'Louvre S 1592 (ED 861)',
    'Swiss private coll.',
    'Paestum 31755, from C. Vannullo (1975), T. 5',
    'Once Los Angeles Market, Superior Stamp and Coin Co.',
    'Pontecagnano 26416',
    'Paestum 21208',
    'Louvre K 350',
    'Once London Market, Sotheby',
    'Paestum 21233',
    'Tatefield Hall (near Harrogate), Kent coll. 379',
    'Paestum 4957',
    'Paestum 21556',
    'Paestum 5658',
    'Madrid 11395',
    'Paestum 4956',
    'Paestum 21427',
    'Paestum 5429',
    'Tatefield Hall, Kent coll. 702',
    'Pontecagnano 36115',
    'Once Freiburg Market, Puhze',
    'Geneva M F 244',
    'Zurich, University 3934',
    'Paestum 21581',
    'Madrid 11283',
    'Naples 124283',
    'Madrid 11282 (L. 508)',
    'Pontecagnano 36477',
    'Paestum 4943',
    'Gela 9183 (fr.) from Monte Saraceno',
    'Paestum 21526',
    'Paestum 7448',
    'Okayama 77',
    'Paestum 22661',
    'Paestum 7428',
    'Not specified',
    'Paestum 1254',
    'Paestum 20294',
    'Paestum 26637',
    'Once New York Market, Royal-Athena Galleries',
    'Cambridge (Mass.), Harvard University, Peabody Museum',
    'Once Stuttgart Market, Kricheldorf',
    'Louvre N 2933 (lid) + 2971 (bowl)',
    'New York 65.11.18',
    'Paestum 31756',
    'Salerno, Mus. Prov. 1319',
    'Paestum 5046',
    'Paestum 5688',
    'Paestum 5696',
    'Paestum 22609',
    'Paestum 32392',
    'Paestum 32865',
    'Paestum 6550',
    'Madrid',
    'Paestum 20139',
    'Paestum 32010',
    'Paestum 22340',
    'Naples Stg. 682',
    'Tatefield Hall, Kent coll.',
    'Paestum, V S 2647',
    'Oxford 1945.79',
    'Paestum 5402',
    'Paestum 5459',
    'Paestum 32218',
    'Athens Market, Acheloos Gallery',
    'Paestum 5774',
    'Paestum 5973',
    'Paestum 6659',
    'Paestum 20212',
    'Paestum 20308',
    'Pontecagnano 36116',
    'Pontecagnano 47805',
    'Moscow 487',
    'Boston 19.308',
    'Paestum 5135',
    'Naples 734',
    'Paestum 5700',
    'Paestum 5513',
    'Paestum 31999',
    'Paestum 22593',
    'Paestum 23054',
    'Paestum 21692',
    'Paestum 22347',
    'Paestum 32222',
    'Paestum 32322',
    'Paestum 40983',
    'Paestum 31889',
    'Paestum 7439',
    'Paestum 22572',
    'Paestum 5488',
    'Paestum 5692',
    'Paestum 5565',
    'Padula, Museo Lucano',
    'Paestum 21151',
    'Geneva I 93',
    'Pontecagnano 36113',
    'Madrid 11261',
    'Braunschweig A T 372',
    'Paestum 31898',
    'Paestum 32851',
    'Paestum 40961',
    'Paestum 20310',
    'Mnichovo Hradiste, Casde 1613',
    'Geneva',
    'Naples, private coll. (2) 4-15-1',
    'Paestum 4802',
    'Madrid 11368 (L. 362)',
    'Paestum 20188',
    'Paestum 39126',
    'Paestum 6113',
    'Paestum 22325',
    'Salerno, Mus. Prov. PC 1322, from Pontecagnano',
    'Naples, private coll. (2) 4-15-2',
    'London Market, Charles Ede Ltd., ex Sotheby',
    'Salerno, from Oliveto Citra',
    'Rome, Villa Giulia, ex Castellani coll.',
    'Leningrad 376 (St. 1793)',
    'Madrid 11374 (L. 366)',
    'Berlin F 3605',
    'Paris Market, Galerie Mythes et Legendes, Sale Cat. 14 (1981), no. 2951',
    'Madrid 11367',
    'Madrid 11370',
    'Madrid 11371',
    'Paestum 22256',
    'Paestum 22782',
    'Paestum 6561',
    'Madrid 11373',
    'Madrid 11369',
    'New York Market, Andre Emmerich Gallery G R 247',
    'Paestum 20144',
    'Madrid 11372',
    'B.M. F262',
    'Bochum S 1011',
    'Naples 2550 (inv. 82095), from Paestum',
    'Princeton 79.3',
    'Cleveland 85-50',
    'Toledo 77.30',
    'Perugia, private coll.',
    'Paestum 26651, from C. Gaudo (1970), T. 3',
    'Once Swiss Market, Hecht',
    'Bochum, Ruhr-Universitat',
    'Paestum 20298, from C. Licinella (1967), T. 13',
    'Paestum 32130, from Tempa Rossa di Fonte (1964), T. 3',
    'Paestum 20303',
    'Paestum 20295',
    'Paestum 20296',
    'Paestum 20301',
    'Paestum 20302',
    'Paestum 20293',
    'Paestum 21560',
    'New York Market, Royal-Athena Galleries H F K 06',
    'Tampa (Florida), Zewadski coll. (ex N. German private coll.)',
    'Turin, private coll.',
    'Paestum 21626',
    'S. Agata 200',
    'Melbourne, La Trobe University 85.01',
    'Madrid 11444 (L. 436)',
    'Paestum 26605',
    'Paestum IV/462',
    'Melbourne, G. Geddes coll.',
    'Boston 19.309',
    'London Market, B.A. Seaby Ltd.',
    'Paestum 21481',
    'Naples 786 (inv. 82760)',
    'Los Angeles Market, Barakat Gallery',
    'Madrid 11391 (L. 492)',
    'Paestum 5052',
    'Paestum 5401',
    'Madrid 11241 (L. 404)',
    'Pontecagnano, from T. 3711',
    'Madrid 11454 (L. 446)',
    'Paestum 5045',
    'B.M. F 154',
    'Port Sunlight 5043',
    'Berlin F 3025',
    'Boston 1986.263',
    'Boston 99.540',
    'San Francisco, M.H. de Young Museum 225.24865',
    'Leningrad inv. 360',
    'Sydney 48-05',
    'Brussels R 261',
    'Sydney 48.06',
    'Naples 1793',
    'Vienna 622',
    'Benevento 601 S',
    'Benevento 28497',
    'Vienna 964',
    'Turin 4700',
    'Buffalo, Society of Nat. Sciences C 12849',
    'Brussels R 277',
    'Vatican U 24',
    'Naples, private coll. (2) 4-1-7',
    'Louvre K 258',
    'Turin 4696',
    'Lisbon, Duke of Palmella',
    'Vienna 2949',
    'Vienna 527',
    'Louvre N 3148',
    'Louvre E D 718',
    'Naples 946 (inv. 82652)',
    'Louvre K 325',
    'Leiden K 1960/4',
    'Vienna 478',
    'Louvre K 315',
    'Naples 828 (inv. 81889)',
    'Vienna 287',
    'Turin 4729',
    'B.M. F 253',
    'Vienna 724',
    'Lost—Tischbein I 26',
    'Graham Geddes coll. P 5:2',
    'Naples 1778 (inv. 82127)',
    'Moscow 735',
    'Once Deepdene, Hope coll. 281',
    'Once Berlin Market, Bassenge, Auktion 19, 16-20 May 1972',
    'Naples 1779 (inv. 81731)',
    'Paestum, from S. Venera (31.5.1976), Lato E, trench IV.',
    'Salerno, Soprintendenza, from Pontecagnano',
    'Paestum 6623',
    'Paestum 21404',
    'Paestum HU/32',
    'Budapest 75.44A',
    'Paestum 20347',
    'Madrid 11568',
    'Madrid 11136',
    'Paestum 22306',
    'Paestum 5214',
    'Paestum 6591',
    'Paestum 4831',
    'Paestum 20351',
    'Paestum 22316-7',
    'Paestum 20341',
    'San Antonio (Texas), Gilbert M. Denman, Jr. coll.',
    'Paestum 5200',
    'Paestum 21629',
    'Paestum 7464',
    'Naples 124288',
    'Geneva Market, Koutoulakis',
    'Naples 2267',
    'Paestum 21416',
    'Naples 1784',
    'Paestum 20338',
    'Paestum 5602',
    'Naples 1788',
    'Naples 3426',
    'Freiburg Market',
    'Paestum 5425',
    'Paestum 21485',
    'Palermo 2206',
    'Berlin F 3081',
    'Naples 1785 (inv. 81677)',
    'Naples 1794 (inv. 81681)',
    'Madrid 11493 (L. 476)',
    'Paestum 4939',
    'Paestum 21185',
    'Naples 1792 (inv. 81676)',
    'Paestum 24322',
    'Paestum 4915',
    'Paestum 21415',
    'Vienna 103',
    'Palermo 5532',
    'Naples 2583',
    'Naples 2589',
    'Naples 3468',
    'Madrid 11293',
    'Paestum 24320',
    'Basel',
    'Paestum 4938',
    'Paestum 4983',
    'Paestum 21704',
    'Paestum 4833',
    'Paestum 21414',
    'Paestum 22906',
    'Naples 2681',
    'Geneva Market',
    'Paestum 21539',
    'Paestum 5955',
    'B.M. 1957.2-12.6',
    'Madrid 11230',
    'Paestum 6258',
    'Paestum 31891',
    'Paestum 21527',
    'Paestum 28902',
    'Paestum 6161',
    'Paestum 1422',
    'Paestum 6236',
    'Paestum 5535',
    'Paestum 6558',
    'Salerno, Mus. Prov. 1451',
    'Paestum 22586',
    'Paestum 1769',
    'Paestum 5050',
    'New York, private coll. (V. Papagapitou)',
    'Paestum 1275',
    'Paestum 5199',
    'Paestum IV/451',
    'Paestum 6592',
    'Paestum 7140',
    'Paestum 32866',
    'Madrid 11327 (L. 528)',
    'Once Zurich Market, Arete inv. 2868',
    'Paestum, from C. Andriuolo (1982), T. 680',
    'Once Zurich Market, Galerie Fortuna',
    'Paestum 20345',
    'Paestum 4930',
    'Madrid 11315 (L. 520)',
    'Madrid 11314 (L. 527)',
    'Once Geneva Market, Koutoulakis',
    'Paestum HU/37',
    'Paestum HUZ/105B and 106S',
    'Madrid 11521 (L. 449)',
    'Paestum 4913',
    'Paestum 5065',
    'Paestum 21402',
    'Paestum 22308',
    'Berlin F 3213',
    'Madrid 11535 (L. 463)',
    'Palermo, old no. 1005',
    'Paestum 31774',
    'Paestum 5435',
    'Paestum 21702',
    'Paestum 24671',
    'Paestum 20348',
    'Madrid 11497 (L. 480)',
    'Madrid 11498 (L. 483)',
    'Paestum 23098',
    'Geneva I 718',
    'Once Zurich Market, Arete inv. 2866',
    'Naples 124287',
    'Paestum 21703',
    'Paestum 5067',
    'Naples 128018',
    'Princeton, Art Museum 37.255',
    'San Francisco, Mr. Rainer Kreisel',
    'Madrid 11286 (L. 513)',
    'Paestum 5063',
    'Paestum 6043',
    'Once New York Market',
    'Once New York Market, Royal-Athena Galleries SLP 12',
    'Paestum 21401',
    'Paestum 32863',
    'Paestum 21184',
    'Naples 2592 (inv. 82530)',
    'Paestum 4953',
    'S. Francisco, State University',
    'S. Francisco, State University, De Bellis coll. 90',
    'Paestum 22309',
    'Melbourne, Geddes coll. P 5:1',
    'Paestum 5180',
    'Paestum 5134',
    'Paestum 32015',
    'Paestum 5511',
    'Louvre K 302',
    'Paestum 5146',
    'Madrid 11238',
    'Paestum 5213',
    'Madrid 11236',
    'Paestum 4954',
    'Paestum 31992',
    'Paestum 32323',
    'Paestum 21678',
    'Salerno, Mus. Prov',
    'Paestum 4836',
    'Paestum 4925',
    'Paestum 5702',
    'Paestum 5226',
    'Once New York Market, Sotheby Parke Bernet, Sale Cat. 16 May 1980, no. 187 (ill.)',
    '22314',
    '11456 (L. 442)',
    'Paestum 31998',
    'Paestum 20317',
    'Paestum 23099',
    'Paestum 21198',
    'Paestum 21490',
    'Paestum 22120',
    'Paestum 6259',
    'Paestum 4832',
    'Paestum 32000',
    'Once Zurich Market, 2873',
    'Paestum 4941',
    'Salerno, Mus. Prov. 1448',
    'Paestum 40898',
    'Paestum 32011',
    'Paestum 31997',
    'Paestum 5082',
    'Paestum 4926',
    'Paestum 1276',
    'Paestum 1770',
    'Paestum 4923',
    'Paestum 20344',
    'Paestum 31988',
    'Geneva I 697',
    'Paestum 34860',
    'Paestum 5436',
    'Paestum 5670'
    ]